import { Component, OnDestroy, HostListener, OnInit } from '@angular/core';
import { AuthService } from './shared/services/auth.service';
import * as moment from 'moment';
import { removeLocalStorage } from './shared/helpers/helper';
// import '@vs-design-system/ds-button';
// import '@vs-design-system/ds-input';
// import '@vs-design-system/ds-collapsible';
// import '@vs-design-system/ds-icon';
// import '@vs-design-system/ds-container';
// import '@vs-design-system/ds-pagination';
import { AppInsightsService } from './shared/services/app-insights-service';
import { appInsights } from './shared/insights/appInsights';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { PageView } from './shared/enums/insights/page-view';
import { Event } from './shared/enums/insights/event';
import { v4 as uuidv4 } from 'uuid';
import { TermsService } from './shared/components/terms/terms.service';

moment.locale('es-CL');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent implements OnDestroy {
  showNav = true;
  private timeRemaining: number;
  private previousNameTrack: string;
  constructor(
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly appInsightsService: AppInsightsService,
    public termsService: TermsService
  ) {
    this.auth.refresh(true);
    // this.auth.LogoutClientes(true);
    appInsights.loadAppInsights();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.route.snapshot),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .subscribe((route: ActivatedRouteSnapshot) => {
        const nameTrack: PageView = route.data['viewName']
          ? route.data['viewName']
          : this.router.url;
        if (this.previousNameTrack !== nameTrack) {
          if (!this.previousNameTrack) {
            this.appInsightsService.startTrackEvent(Event.ceScreenTime);
          } else {
            this.appInsightsService.stopTrackEvent(Event.ceScreenTime, {
              pageViewName: this.previousNameTrack,
            });
            this.appInsightsService.startTrackEvent(Event.ceScreenTime);
          }
          this.previousNameTrack = nameTrack;
        }
        this.appInsightsService.uuid = uuidv4();
        this.appInsightsService.policyId = route.paramMap.get('id');
        this.appInsightsService.pageViewParentActive = {
          viewName: route.data['viewName'],
          label: route.data['label'],
        };
        this.appInsightsService.pageViewActive = {
          viewName: route.data['viewName'],
          label: route.data['label'],
        };
        this.appInsightsService.trackPageView(nameTrack, this.router.url);
      });
  }

  @HostListener('window:beforeunload', ['$event'])
  public beforeUnloadHander(): void {
    this.appInsightsService.stopTrackEvent(Event.ceScreenTime, {
      pageViewName: this.previousNameTrack,
    });
  }

  disableNav(): void {
    this.showNav = false;
  }
  ngOnDestroy() {
    removeLocalStorage('token');
  }
}
